import * as React from "react";
import { cn } from "@/lib/cn";

type LogoProps = {
  markHeight?: number;
  variant?: "horizontal" | "vertical" | "mark";
  inverse?: boolean;
  className?: string;
  wordmarkClassName?: string;
};

export function Logo({
  markHeight = 32,
  variant = "horizontal",
  inverse = false,
  className,
  wordmarkClassName,
}: LogoProps) {
  const color = inverse ? "#ffffff" : "currentColor";
  const wordmarkSize = Math.round(markHeight * 0.55);

  const mark = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 894 696"
      style={{ height: markHeight, width: "auto", color }}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M442.487 9.74587C460.893 7.08137 475.999 17.7212 485.714 32.8738C494.351 46.3443 504.51 60.2483 513.64 73.4352L600.479 198.771L794.623 479.811L851.219 561.971C860.191 575.041 869.467 588.331 878.188 601.576C882.672 608.385 885.487 620.059 885.642 628.265C885.899 641.873 880.667 655.011 871.128 664.715C859.591 676.66 845.603 681.607 829.273 681.632C806.824 681.667 784.36 681.647 761.913 681.647L627.739 681.648L562.171 681.654C540.145 681.654 518.679 682.703 497.036 677.998C467.134 671.497 439.84 658.218 417.863 636.712C387.322 606.334 369.896 565.195 369.322 522.117C368.854 476.939 383.502 435.463 415.47 402.919C440.947 377.53 475.072 361.176 511.191 360.671C559.391 359.996 601.213 393.908 600.91 443.91C600.742 471.493 589.752 490.203 570.702 509.267C592.354 505.799 606.879 499.15 622.15 482.983C624.99 479.888 627.634 476.617 630.066 473.191C647.369 448.598 653.083 417.888 648.108 388.386C640.931 345.826 613.887 309.47 578.965 284.948C535.057 254.237 480.732 242.273 427.989 251.698C393.938 257.841 361.841 272.014 334.36 293.042C271.524 340.456 238.436 410.315 214.342 483.334C198.563 531.151 187.251 583.512 158.298 625.49C139.483 652.77 111.503 674.184 78.4188 680.22C62.0377 683.208 44.7774 681.484 30.8328 671.574C19.4345 663.616 11.6916 651.429 9.3291 637.728C5.26463 612.705 17.4419 599.741 30.4808 580.918L63.0408 533.866L166.517 383.918L338.569 135.716L389.454 61.5815C397.331 50.08 405.07 38.4843 413.058 27.0607C420.058 17.0498 430.625 11.6106 442.487 9.74587Z"
      />
    </svg>
  );

  const wordmark = (
    <span
      className={wordmarkClassName}
      style={{
        fontFamily: '"General Sans", system-ui, sans-serif',
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        fontSize: wordmarkSize,
        lineHeight: 1,
        color,
      }}
    >
      XCORP
    </span>
  );

  if (variant === "mark") {
    return <span className={cn("inline-flex", className)}>{mark}</span>;
  }

  if (variant === "vertical") {
    return (
      <span
        className={cn("inline-flex flex-col items-center", className)}
        style={{ color }}
      >
        {mark}
        <span style={{ marginTop: "1rem" }}>{wordmark}</span>
      </span>
    );
  }

  return (
    <span
      className={cn("inline-flex items-center gap-[0.6em] group-data-[collapsible=icon]:gap-0", className)}
      style={{ color }}
    >
      {mark}
      {wordmark}
    </span>
  );
}
